import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var icon = /*#__PURE__*/css("margin-left:4px;color:", colors.neutral.heavy.default, ";");